import { TranslateRounded } from '@mui/icons-material'
import { Box, Button, Container, Grid, InputLabel, MenuItem, ThemeProvider, Toolbar, Typography } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet } from 'react-router'
import { useNavigate } from 'react-router'
import logo from '../../../../assets/Images/logos/logodark.svg'
import { setGlobalLanguage } from '../../../../redux/actions/global'
import { getLanguages } from '../../../../redux/actions/languages'
import { IRootState } from '../../../../redux/types'
import { FormControlLanguage, HelpAppBar, SelectLanguage } from '../../styles/HelpCenterStyles'
import { clientThemeV5 } from '../../styles/themes/ClientTheme'
import Footer from './Footer'
import { verifyUser } from '@/redux/actions/auth'

function NavLayout() {
  const { i18n } = useTranslation()
  const { t } = useTranslation(['helpcenter'])
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { globalLanguageId } = useSelector((state: IRootState) => state.global)

  useEffect(() => {
    dispatch(getLanguages())
  }, [dispatch])

  useEffect(() => {
    if (authUser === null) dispatch(verifyUser())
  }, [authUser])

  const handleGlobalLanguage = (languageId: number, languageCode: string) => {
    localStorage.setItem('globalLanguageId', languageId.toString())
    localStorage.setItem('globalLanguageCode', languageCode)
    dispatch(setGlobalLanguage(languageId))
    i18n.changeLanguage(languageCode)
  }

  const handleContact = () => {
    navigate('/ayuda')
  }

  return (
    <ThemeProvider theme={clientThemeV5}>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '90vh' }}>
        <HelpAppBar position="static">
          <Toolbar>
            <Container maxWidth="xl" sx={{ padding: 0 }}>
              <Grid container justifyContent="space-between">
                <Grid item xs={6} sm={6}>
                  <Box display="flex" alignItems="center" sx={{ gap: 4, minHeight: 50 }}>
                    <Box
                      onClick={handleContact}
                      sx={theme => ({
                        height: 24,
                        [theme.breakpoints.down('sm')]: {
                          height: 20
                        }
                      })}
                    >
                      <img src={String(logo)} alt={`Logo de ${import.meta.env.VITE_NAME}`} />
                    </Box>
                    <Typography color="text.secondary">|</Typography>
                    <Typography color="text.secondary">{t('helpcenter')}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 4, justifyContent: 'flex-end', minHeight: 50 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                      <Button href="/inicio" variant="contained" color="primary">
                        Volver a {import.meta.env.VITE_NAME}
                      </Button>
                    </Box>
                    {authUser !== null &&
                      authUser.languages_name !== undefined &&
                      globalLanguageId !== null &&
                      authUser.languages_name.find((language: any) => language.id === Number(globalLanguageId)) !== undefined && (
                        <FormControlLanguage>
                          <TranslateRounded fontSize="small" sx={{ marginRight: 1 }} />
                          <InputLabel id="languages" />
                          <SelectLanguage
                            labelId="languages"
                            id="optionsLanguage"
                            defaultValue={globalLanguageId !== null ? globalLanguageId : 1}
                          >
                            {authUser.languages_name.map((language: any) => (
                              <MenuItem
                                key={language.id}
                                onClick={() => handleGlobalLanguage(language.id, language.code)}
                                value={language.id}
                              >
                                {language.code.toUpperCase()}
                              </MenuItem>
                            ))}
                          </SelectLanguage>
                        </FormControlLanguage>
                      )}
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Toolbar>
        </HelpAppBar>
        <Outlet />
      </Box>
      <Footer />
    </ThemeProvider>
  )
}

export default NavLayout
